<template>
  <div class="flux-regalo">
    <div class="flux-regalo__title">{{ $t("guest.purchaseFlow.allSet") }}</div>

    <div class="flux-regalo__msg">
      {{ $t("guest.purchaseFlow.allSetDescription", { name: myList.ownerName }) }}
    </div>
    
    <div class="flux-regalo__actions">
      <button class="button button--primary" @click.prevent="goToCongratsMessage()">
        {{ $t("generic.yes") }}
      </button>
    </div>
    
  </div>
</template>
<script>
import CompradoYa from "./mixins/CompradoYa";
import { mapGetters } from "vuex";

export default {
  name: "FluxRegaloStep4",
  mixins: [CompradoYa],
  props: {
    retailer: {
      required: true
    },
    product: {
      required: true,
    },
    list: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      myList: "myList",
    }),
  },
};
</script>
